export const SLIDER_TYPES = [
  "pop_up_banner",
  "banner",
  "quik_delivery",
  "divided",
  "middle",
  "cart",
];

const TYPE_I18N_KEYS = {
  quik_delivery: "quick_delivery",
  pop_up_banner: "pop_up_banner",
  cart: "cart_slider",
};

export function getSliderTypeI18nKey(type) {
  return TYPE_I18N_KEYS[type] || type;
}

export function getSliderTypeOptions(vm) {
  return SLIDER_TYPES.map((id) => ({
    id,
    name: vm.$t(`titles.${getSliderTypeI18nKey(id)}`),
  }));
}

export function getSliderTypeLabel(vm, type) {
  if (!type) return vm.$t("notFound");
  return vm.$t(`titles.${getSliderTypeI18nKey(type)}`);
}
